import { IntroductionWidget } from '../../../../shared/components/IntroductionWidget/IntroductionWidget';
import { PipelineStrings } from '../../../strings';
import { IntroductionWidgetIcon } from '../../../../shared/components/IntroductionWidget/IntroductionWidgetIcon';
import { Icon } from '../../../../icon/Icon';
import { useCreatePipeline } from '../../../hooks/useCreatePipeline';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { PipelineListTrackers } from '../../../tracking/pipeline-list-trackers';

export function PipelineIntro() {
  const { createPipeline, creatingPipeline } = useCreatePipeline({ showSuccessToast: false });
  const { eventTrack } = useAnalyticsTracker();

  return (
    <IntroductionWidget
      dataId=''
      entity='Pipelines'
      title={PipelineStrings.introTitle}
      description={PipelineStrings.introDescription}
      illustration={
        <>
          <IntroductionWidgetIcon iconName='database' dataId='db' />

          <Icon name='add-arrow-right' className='text-accent-primary mx-9' size={5} />

          <IntroductionWidgetIcon iconName='destinations' dataId='destination' />
        </>
      }
      buttonProps={{
        children: creatingPipeline ? 'Creating...' : 'Create Your First Pipeline',
        disabled: creatingPipeline,
        onClick: () => {
          eventTrack({
            action:
              PipelineListTrackers.PIPELINE_TRACKER_PIPELINE_LIST_PIPELINE_INTRO_CREATE_PIPELINE_CLICK
          });

          createPipeline();
        }
      }}
    />
  );
}
